import { getSDKSrc } from './get-sdk-src';
import { getPreconnectHref } from './utils';
var promise = null;
var NOOP = function NOOP() {};
export var loadCSMSDK = function loadCSMSDK(_ref) {
  var site = _ref.site,
    siteId = _ref.siteId,
    widgetId = _ref.widgetId,
    _ref$debug = _ref.debug,
    debug = _ref$debug === void 0 ? NOOP : _ref$debug;
  if (!promise) {
    promise = new Promise(function (resolve, reject) {
      if (typeof window === 'undefined') {
        debug({
          message: '[SDKLoader]: window is undefined'
        });
        reject(new Error('Failed to load CSM SDK: window is undefined'));
      }
      if (window.CSM && !('__q__' in window.CSM)) {
        debug({
          message: '[SDKLoader]: window.CSM already exists'
        });
        resolve(window.CSM);
      }
      var script = document.createElement('script');
      script.src = getSDKSrc({
        site: site,
        siteId: siteId,
        widgetId: widgetId
      });
      script.setAttribute('async', '');
      script.type = 'text/javascript';
      script.onerror = function () {
        reject(new Error('Failed to load CSM SDK script: onerror'));
      };
      script.onload = function () {
        debug({
          message: '[SDKLoader]: script onload called'
        });
        if (window.CSM && !('__q__' in window.CSM)) {
          debug({
            message: '[SDKLoader]: CSM SDK found after script onload'
          });
          resolve(window.CSM);
        } else {
          debug({
            message: '[SDKLoader]: CSM SDK not found after script onload'
          });
          reject(new Error('Failed to load CSM SDK: window.CSM is undefined'));
        }
      };
      debug({
        message: '[SDKLoader]: CSM SDK appended to body'
      });
      document.body.appendChild(script);

      /**
       * Preconnect to initialise the connection ahead of loading any iframe
       * which will load static assets from the JCS widget domain.
       */
      var link = document.createElement('link');
      var linkHref = getPreconnectHref(site);
      link.rel = 'preconnect';
      link.href = linkHref;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
      debug({
        message: "[SDKLoader]: CSM SDK preconnecting to ".concat(linkHref)
      });
    });
  }
  return promise;
};